<template>
	<div>
		<div style="margin-bottom: 18px;margin-top: 18px;">
			<label style="color: #333333;margin-left: 20px;">名称：</label>
			<el-input v-model="name" placeholder="请输入产品名称" suffix-icon="el-icon-search" style="width: 200px;"
				size="small" @keyup.enter.native="getData"></el-input>
			<label style="color: #333333;margin-left: 20px;">类型：</label>
			<el-select v-model="type" placeholder="请选择">
				<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>

			<el-button type="primary" style="margin-left: 15px;" size="small" @click="getData">查询</el-button>
			<el-button type="success" style="margin-left: 15px;" size="small" @click="reset">重置</el-button>
			<el-button type="warning" style="margin-left: 15px;" size="small" @click="add">新增</el-button>
		</div>
		<el-table :data="tableData" :header-cell-style="{background:'#f2f5fc',color:'#55555'}" border
			highlight-current-row>
			<el-table-column prop="id" align="center" label="ID" width="60">
			</el-table-column>
			<el-table-column prop="name" align="center" label="名称(中文)" width="180">
			</el-table-column>
			<el-table-column prop="nameEg" align="center" label="名称(英文)" width="180">
			</el-table-column>
			<el-table-column prop="firstTitle" align="center" label="详情(中文)" width="300">
			</el-table-column>
			<el-table-column prop="firstTitleEg" align="center" label="详情(英文)" width="300">
			</el-table-column>
			<el-table-column prop="image" align="center" label="图片" width="100">
				<template slot-scope="scope">
					<el-image style="width: 50px; height: 50px" :src="scope.row.image"
						:preview-src-list="scope.row.srcList">
					</el-image>
				</template>
			</el-table-column>
			<!-- 	<el-table-column prop="type" align="center" label="类型(中文)" width="100">

			</el-table-column>

			<el-table-column prop="typeEg" align="center" label="类型(英文)" width="100">

			</el-table-column> -->
			<el-table-column prop="isSy" align="center" label="类型">
				<template slot-scope="scope">
					<el-tag :type="scope.row.type == 1?'danger':'primary'" disable-transitions>
						{{ scope.row.type == 1?'行业应用':'产品'}}
					</el-tag>
				</template>
			</el-table-column>

			<el-table-column prop="operate" align="center" label="操作" width="660">
				<template slot-scope="scope">
					<el-button type="success" size="small" @click="mod(scope.row,1)">编辑产品</el-button>
					<el-button type="success" size="small" @click="mod(scope.row,2)">编辑第一模块</el-button>
					<el-button type="success" size="small" @click="mod(scope.row,3)">编辑第二模块</el-button>
					<el-button type="success" size="small" @click="mod(scope.row,4)">编辑第三模块</el-button>
					<el-button type="success" size="small" @click="mod(scope.row,5)">编辑第四模块</el-button>
					<el-popconfirm title="确定删除吗？" @confirm="deleteRow(scope.row)"
						style="margin-left: 10px;">
						<el-button type="danger" slot="reference" size="small">删除</el-button>
					</el-popconfirm>

				</template>
			</el-table-column>
		</el-table>

		<div style="align-content: center;text-align: center;margin: 20px;">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
				:page-sizes="[2, 5, 10, 20]" :page-size="10" layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>

		<el-dialog :title="textTitle" :visible.sync="centerDialogVisible" width="50%" center>
			<el-form ref="form" :model="form" :rules="rules" label-width="100px">

				<el-form-item label="名称(中文)" prop="name">
					<el-col :span="20">
						<el-input v-model="form.name"></el-input>
					</el-col>
				</el-form-item>
				<el-form-item label="名称(英文)" prop="nameEg">
					<el-col :span="20">
						<el-input v-model="form.nameEg"></el-input>
					</el-col>
				</el-form-item>

				<el-form-item label="标题(中文)" prop="firstTitle">
					<el-col :span="20">
						<!-- <el-col :span="20" style="border: 1px solid gray;"> -->
						<!-- <tinymce-editor v-model="form.content" :init="initEditor" /> -->
						<el-input v-model="form.firstTitle" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>


				<el-form-item label="标题(英文)" prop="firstTitleEg">
					<!-- <el-col :span="20" style="border: 1px solid gray;"> -->
					<el-col :span="20">
						<!-- <tinymce-editor v-model="form.contentEg" :init="initEditor" /> -->
						<el-input v-model="form.firstTitleEg" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>

				<el-form-item label="子标题(中文)" prop="firstSubTitle">
					<el-col :span="20">
						<!-- <el-col :span="20" style="border: 1px solid gray;"> -->
						<!-- <tinymce-editor v-model="form.content" :init="initEditor" /> -->
						<el-input v-model="form.firstSubTitle" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>


				<el-form-item label="子标题(英文)" prop="firstSubTitleEg">
					<!-- <el-col :span="20" style="border: 1px solid gray;"> -->
					<el-col :span="20">
						<!-- <tinymce-editor v-model="form.contentEg" :init="initEditor" /> -->
						<el-input v-model="form.firstSubTitleEg" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>


				<el-form-item label="图片" prop="url">
					<el-col :span="20">
						<!-- <el-input v-model="form.remark"></el-input> -->
						<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
							:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload1"
							v-loading.fullscreen.lock="fullscreenLoading">
							<img v-if="form.image" :src="form.image" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且尺寸宽高比例为1:2</div>
						</el-upload>
					</el-col>
				</el-form-item>


				<el-form-item label="类型" prop="account">
					<el-col :span="20">
						<el-select v-model="form.type" placeholder="请选择">
							<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-col>
				</el-form-item>

				<!-- 	<el-form-item label="是否首页展示">
					<el-radio v-model="form.isSy" label="1">是</el-radio>
					<el-radio v-model="form.isSy" label="2">否</el-radio>
				</el-form-item> -->

			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save">{{ btnText }}</el-button>
			</span>
		</el-dialog>

		<el-dialog :title="textTitle" :visible.sync="centerDialogVisible1" width="50%" center>
			<el-form ref="form" :model="form" :rules="rules" label-width="150px">

				<el-form-item label="标签标题(中文)" prop="firstItemTitle">
					<el-col :span="20">
						<el-input v-model="form.firstItemTitle"></el-input>
					</el-col>
				</el-form-item>
				<el-form-item label="标签标题(英文)" prop="firstItemTitleEg">
					<el-col :span="20">
						<el-input v-model="form.firstItemTitleEg"></el-input>
					</el-col>
				</el-form-item>

				<el-form-item label="标签内容(中文)" prop="firstItemContent">
					<el-col :span="20">
						<!-- <el-col :span="20" style="border: 1px solid gray;"> -->
						<!-- <tinymce-editor v-model="form.content" :init="initEditor" /> -->
						<el-input v-model="form.firstItemContent" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>


				<el-form-item label="标签内容(英文)" prop="firstItemContentEg">
					<!-- <el-col :span="20" style="border: 1px solid gray;"> -->
					<el-col :span="20">
						<!-- <tinymce-editor v-model="form.contentEg" :init="initEditor" /> -->
						<el-input v-model="form.firstItemContentEg" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>

				<el-form-item label="标签标题1(中文)" prop="firstItemTitle1">
					<el-col :span="20">
						<!-- <el-col :span="20" style="border: 1px solid gray;"> -->
						<!-- <tinymce-editor v-model="form.content" :init="initEditor" /> -->
						<el-input v-model="form.firstItemTitle1" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>


				<el-form-item label="标签标题1(英文)" prop="firstItemTitleEg1">
					<!-- <el-col :span="20" style="border: 1px solid gray;"> -->
					<el-col :span="20">
						<!-- <tinymce-editor v-model="form.contentEg" :init="initEditor" /> -->
						<el-input v-model="form.firstItemTitleEg1" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>

				<el-form-item label="标签内容1(中文)" prop="firstItemContent1">
					<el-col :span="20">
						<!-- <el-col :span="20" style="border: 1px solid gray;"> -->
						<!-- <tinymce-editor v-model="form.content" :init="initEditor" /> -->
						<el-input v-model="form.firstItemContent1" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>


				<el-form-item label="标签内容1(英文)" prop="firstItemContentEg1">
					<!-- <el-col :span="20" style="border: 1px solid gray;"> -->
					<el-col :span="20">
						<!-- <tinymce-editor v-model="form.contentEg" :init="initEditor" /> -->
						<el-input v-model="form.firstItemContentEg1" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>

				<el-form-item label="标签标题2(中文)" prop="firstItemTitle2">
					<el-col :span="20">
						<!-- <el-col :span="20" style="border: 1px solid gray;"> -->
						<!-- <tinymce-editor v-model="form.content" :init="initEditor" /> -->
						<el-input v-model="form.firstItemTitle2" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>


				<el-form-item label="标签标题2(英文)" prop="firstItemTitleEg2">
					<!-- <el-col :span="20" style="border: 1px solid gray;"> -->
					<el-col :span="20">
						<!-- <tinymce-editor v-model="form.contentEg" :init="initEditor" /> -->
						<el-input v-model="form.firstItemTitleEg2" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>

				<el-form-item label="标签内容2(中文)" prop="firstItemContent2">
					<el-col :span="20">
						<!-- <el-col :span="20" style="border: 1px solid gray;"> -->
						<!-- <tinymce-editor v-model="form.content" :init="initEditor" /> -->
						<el-input v-model="form.firstItemContent2" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>


				<el-form-item label="标签内容2(英文)" prop="firstItemContentEg2">
					<!-- <el-col :span="20" style="border: 1px solid gray;"> -->
					<el-col :span="20">
						<!-- <tinymce-editor v-model="form.contentEg" :init="initEditor" /> -->
						<el-input v-model="form.firstItemContentEg2" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>

				<el-form-item label="标签标题3(中文)" prop="firstItemTitle3">
					<el-col :span="20">
						<!-- <el-col :span="20" style="border: 1px solid gray;"> -->
						<!-- <tinymce-editor v-model="form.content" :init="initEditor" /> -->
						<el-input v-model="form.firstItemTitle3" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>


				<el-form-item label="标签标题3(英文)" prop="firstItemTitleEg3">
					<!-- <el-col :span="20" style="border: 1px solid gray;"> -->
					<el-col :span="20">
						<!-- <tinymce-editor v-model="form.contentEg" :init="initEditor" /> -->
						<el-input v-model="form.firstItemTitleEg3" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>

				<el-form-item label="标签内容3(中文)" prop="firstItemContent3">
					<el-col :span="20">
						<!-- <el-col :span="20" style="border: 1px solid gray;"> -->
						<!-- <tinymce-editor v-model="form.content" :init="initEditor" /> -->
						<el-input v-model="form.firstItemContent3" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>


				<el-form-item label="标签内容3(英文)" prop="firstItemContentEg3">
					<!-- <el-col :span="20" style="border: 1px solid gray;"> -->
					<el-col :span="20">
						<!-- <tinymce-editor v-model="form.contentEg" :init="initEditor" /> -->
						<el-input v-model="form.firstItemContentEg3" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>

			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible1 = false">取 消</el-button>
				<el-button type="primary" @click="save">{{ btnText }}</el-button>
			</span>
		</el-dialog>

		<el-dialog :title="textTitle" :visible.sync="centerDialogVisible2" width="50%" center>
			<el-form ref="form" :model="form" :rules="rules" label-width="150px">

				<el-form-item label="左侧标题(中文)" prop="secondTitle">
					<el-col :span="20">
						<el-input v-model="form.secondTitle"></el-input>
					</el-col>
				</el-form-item>
				<el-form-item label="左侧标题(英文)" prop="secondTitleEg">
					<el-col :span="20">
						<el-input v-model="form.secondTitleEg"></el-input>
					</el-col>
				</el-form-item>

				<el-form-item label="图片" prop="url">
					<el-col :span="20">
						<!-- <el-input v-model="form.remark"></el-input> -->
						<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
							:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload2"
							v-loading.fullscreen.lock="fullscreenLoading">
							<img v-if="form.secondImg" :src="form.secondImg" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且尺寸宽高为1024*642</div>
						</el-upload>
					</el-col>
				</el-form-item>

				<el-form-item label="右侧标题(中文)" prop="secondTitle1">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.secondTitle1" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.secondTitle1" :init="initEditor" />
					</el-col>
				</el-form-item>


				<el-form-item label="右侧标题(英文)" prop="secondTitleEg1">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.secondTitleEg1" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.secondTitleEg1" :init="initEditor" />
					</el-col>
				</el-form-item>

				<el-form-item label="右侧内容(中文)" prop="secondTitle2">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.secondTitle2" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.secondTitle2" :init="initEditor" />
					</el-col>
				</el-form-item>


				<el-form-item label="右侧内容(英文)" prop="secondTitleEg2">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.secondTitleEg2" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.secondTitleEg2" :init="initEditor" />
					</el-col>
				</el-form-item>

				<el-form-item label="标签列表(中文)" prop="secondTitle3">
					<el-col :span="20">
						<el-input v-model="form.secondTitle3" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>


				<el-form-item label="标签列表(英文)" prop="secondTitleEg3">
					<el-col :span="20">
						<el-input v-model="form.secondTitleEg3" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>

				<el-form-item label="标签列表1(中文)" prop="secondTitle4">
					<el-col :span="20">
						<el-input v-model="form.secondTitle4" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>


				<el-form-item label="标签列表1(英文)" prop="secondTitleEg4">
					<el-col :span="20">
						<el-input v-model="form.secondTitleEg4" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>

				<el-form-item label="标签列表2(中文)" prop="secondTitle5">
					<el-col :span="20">
						<el-input v-model="form.secondTitle5" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>


				<el-form-item label="标签列表2(英文)" prop="secondTitleEg5">
					<el-col :span="20">
						<el-input v-model="form.secondTitleEg5" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>

				<el-form-item label="标签标题3(中文)" prop="secondTitle6">
					<el-col :span="20">
						<el-input v-model="form.secondTitle6" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>


				<el-form-item label="标签标题3(英文)" prop="secondTitleEg6">
					<el-col :span="20">
						<el-input v-model="form.secondTitleEg6" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>

				<el-form-item label="标签列表4(中文)" prop="secondTitle7">
					<el-col :span="20">
						<el-input v-model="form.secondTitle7" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>


				<el-form-item label="标签列表4(英文)" prop="secondTitleEg7">
					<el-col :span="20">
						<el-input v-model="form.secondTitleEg7" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>

				<el-form-item label="标签列表5(中文)" prop="secondTitle8">
					<el-col :span="20">
						<el-input v-model="form.secondTitle8" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>

				<el-form-item label="标签列表5(英文)" prop="secondTitleEg8">
					<el-col :span="20">
						<el-input v-model="form.secondTitleEg8" type="textarea" :rows="3"></el-input>
					</el-col>
				</el-form-item>


			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible2 = false">取 消</el-button>
				<el-button type="primary" @click="save">{{ btnText }}</el-button>
			</span>
		</el-dialog>


		<el-dialog :title="textTitle" :visible.sync="centerDialogVisible3" width="50%" center>
			<el-form ref="form" :model="form" :rules="rules" label-width="150px">

				<el-form-item label="左侧标题(中文)" prop="thirdTitle">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.thirdTitle"></el-input> -->
						<tinymce-editor v-model="form.thirdTitle" :init="initEditor" />
					</el-col>
				</el-form-item>
				<el-form-item label="左侧标题(英文)" prop="thirdTitleEg">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.thirdTitleEg"></el-input> -->
						<tinymce-editor v-model="form.thirdTitleEg" :init="initEditor" />
					</el-col>
				</el-form-item>

				<el-form-item label="左侧内容(中文)" prop="thirdTitle1">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.thirdTitle1" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.thirdTitle1" :init="initEditor" />
					</el-col>
				</el-form-item>


				<el-form-item label="左侧内容(英文)" prop="thirdTitleEg1">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.thirdTitleEg1" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.thirdTitleEg1" :init="initEditor" />
					</el-col>
				</el-form-item>

				<el-form-item label="图片" prop="url">
					<el-col :span="20">
						<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
							:on-success="handleAvatarSuccess1" :before-upload="beforeAvatarUpload5"
							v-loading.fullscreen.lock="fullscreenLoading">
							<img v-if="form.thirdImg" :src="form.thirdImg" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且尺寸宽高为1024*642或550*345</div>
						</el-upload>
					</el-col>
				</el-form-item>


				<el-form-item label="标题(中文)" prop="thirdTitle2">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.thirdTitle2" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.thirdTitle2" :init="initEditor" />
					</el-col>
				</el-form-item>


				<el-form-item label="标题(英文)" prop="thirdTitleEg2">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.thirdTitleEg2" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.thirdTitleEg2" :init="initEditor" />
					</el-col>
				</el-form-item>

				<el-form-item label="内容(中文)" prop="thirdTitle3">
					<el-col :span="20">
						<!-- <el-input v-model="form.thirdTitle3" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.thirdTitle3" :init="initEditor" />
					</el-col>
				</el-form-item>


				<el-form-item label="内容(英文)" prop="thirdTitleEg3">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.thirdTitleEg3" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.thirdTitleEg3" :init="initEditor" />
					</el-col>
				</el-form-item>

				<el-form-item label="图片1" prop="url">
					<el-col :span="20">
						<!-- <el-input v-model="form.remark"></el-input> -->
						<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
							:on-success="handleAvatarSuccess2" :before-upload="beforeAvatarUpload5"
							v-loading.fullscreen.lock="fullscreenLoading">
							<img v-if="form.thirdImg1" :src="form.thirdImg1" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且尺寸宽高为1024*642或550*345</div>
						</el-upload>
					</el-col>
				</el-form-item>


				<el-form-item label="标题1(中文)" prop="thirdTitle4">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.thirdTitle4" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.thirdTitle4" :init="initEditor" />
					</el-col>
				</el-form-item>


				<el-form-item label="标题1(英文)" prop="thirdTitleEg4">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.thirdTitleEg4" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.thirdTitleEg4" :init="initEditor" />
					</el-col>
				</el-form-item>

				<el-form-item label="内容1(中文)" prop="thirdTitle5">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.thirdTitle5" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.thirdTitle5" :init="initEditor" />
					</el-col>
				</el-form-item>


				<el-form-item label="内容1(英文)" prop="thirdTitleEg5">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.thirdTitleEg5" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.thirdTitleEg5" :init="initEditor" />
					</el-col>
				</el-form-item>


			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible3 = false">取 消</el-button>
				<el-button type="primary" @click="save">{{ btnText }}</el-button>
			</span>
		</el-dialog>


		<el-dialog :title="textTitle" :visible.sync="centerDialogVisible4" width="50%" center>
			<el-form ref="form" :model="form" :rules="rules" label-width="150px">

				<el-form-item label="左侧标题(中文)" prop="fourthLeftTitle">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.fourthLeftTitle"></el-input> -->
						<tinymce-editor v-model="form.fourthLeftTitle" :init="initEditor" />
					</el-col>
				</el-form-item>
				<el-form-item label="左侧标题(英文)" prop="fourthLeftTitleEg">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.fourthLeftTitleEg"></el-input> -->
						<tinymce-editor v-model="form.fourthLeftTitleEg" :init="initEditor" />
					</el-col>
				</el-form-item>

				<el-form-item label="标题(中文)" prop="fourthTitle">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.fourthTitle" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.fourthTitle" :init="initEditor" />
					</el-col>
				</el-form-item>


				<el-form-item label="标题(英文)" prop="fourthTitleEg">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.fourthTitleEg" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.fourthTitleEg" :init="initEditor" />
					</el-col>
				</el-form-item>

				<el-form-item label="内容(中文)" prop="fourthContent">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.fourthContent" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.fourthContent" :init="initEditor" />
					</el-col>
				</el-form-item>


				<el-form-item label="内容(英文)" prop="fourthContentEg">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.fourthContentEg" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.fourthContentEg" :init="initEditor" />
					</el-col>
				</el-form-item>

				<el-form-item label="图片" prop="url">
					<el-col :span="20">
						<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
							:on-success="handleAvatarSuccess3" :before-upload="beforeAvatarUpload2"
							v-loading.fullscreen.lock="fullscreenLoading">
							<img v-if="form.fourthImg" :src="form.fourthImg" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且尺寸宽高为1024*642</div>
						</el-upload>
					</el-col>
				</el-form-item>


				<el-form-item label="标题1(中文)" prop="fourthTitle1">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.fourthTitle1" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.fourthTitle1" :init="initEditor" />
					</el-col>
				</el-form-item>


				<el-form-item label="标题1(英文)" prop="fourthTitleEg1">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.fourthTitleEg1" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.fourthTitleEg1" :init="initEditor" />
					</el-col>
				</el-form-item>

				<el-form-item label="内容1(中文)" prop="fourthContent1">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.fourthContent1" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.fourthContent1" :init="initEditor" />
					</el-col>
				</el-form-item>


				<el-form-item label="内容1(英文)" prop="fourthContentEg1">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.fourthContentEg1" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.fourthContentEg1" :init="initEditor" />
					</el-col>
				</el-form-item>

				<el-form-item label="图片1" prop="url">
					<el-col :span="20">
						<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
							:on-success="handleAvatarSuccess4" :before-upload="beforeAvatarUpload2"
							v-loading.fullscreen.lock="fullscreenLoading">
							<img v-if="form.fourthImg1" :src="form.fourthImg1" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且尺寸宽高为1024*642</div>
						</el-upload>
					</el-col>
				</el-form-item>

				<el-form-item label="标题2(中文)" prop="fourthTitle2">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.fourthTitle2" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.fourthTitle2" :init="initEditor" />
					</el-col>
				</el-form-item>


				<el-form-item label="标题2(英文)" prop="fourthTitleEg2">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.fourthTitleEg2" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.fourthTitleEg2" :init="initEditor" />
					</el-col>
				</el-form-item>

				<el-form-item label="内容2(中文)" prop="fourthContent2">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.fourthContent2" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.fourthContent2" :init="initEditor" />
					</el-col>
				</el-form-item>


				<el-form-item label="内容2(英文)" prop="fourthContentEg2">
					<el-col :span="20" style="border: 1px solid gray;">
						<!-- <el-input v-model="form.fourthContentEg2" type="textarea" :rows="3"></el-input> -->
						<tinymce-editor v-model="form.fourthContentEg2" :init="initEditor" />
					</el-col>
				</el-form-item>

				<el-form-item label="图片2" prop="url">
					<el-col :span="20">
						<el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false"
							:on-success="handleAvatarSuccess5" :before-upload="beforeAvatarUpload2"
							v-loading.fullscreen.lock="fullscreenLoading">
							<img v-if="form.fourthImg2" :src="form.fourthImg2" class="avatar">
							<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且尺寸宽高为1024*642</div>
						</el-upload>
					</el-col>
				</el-form-item>


			</el-form>

			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible4 = false">取 消</el-button>
				<el-button type="primary" @click="save">{{ btnText }}</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import TinymceEditor from '../../components/TinymceEditor/index.vue';
	export default {
		name: "UserMange",
		components: {
			TinymceEditor
		},
		data() {
			return {
				options: [{
					value: '1',
					label: '行业应用'
				}, {
					value: '2',
					label: '产品'
				}],
				rules: {
					name: [{
						required: true,
						message: '请输入名字',
						trigger: 'blur'
					}]
				},
				tableData: [],
				pageSize: 10,
				page: 1,
				total: 0,
				name: "",
				type: "",
				centerDialogVisible: false,
				centerDialogVisible1: false,
				centerDialogVisible2: false,
				centerDialogVisible3: false,
				centerDialogVisible4: false,
				form: {
					id: "",
					name: "",
					nameEg: "",
					image: "",
					content: "",
					contentEg: "",
					firstTitle: "",
					firstTitleEg: "",
					type: "",
					isSy: 1,
					firstSubTitle: "",
					firstSubTitleEg: "",
					firstItemTitle: "",
					firstItemTitleEg: "",
					firstItemContent: "",
					firstItemContentEg: "",
					firstImg: "",
					firstItemTitle1: "",
					firstItemTitleEg1: "",
					firstItemContent1: "",
					firstItemContentEg1: "",
					firstItemTitle2: "",
					firstItemTitleEg2: "",
					firstItemContent2: "",
					firstItemContentEg2: "",
					firstItemTitle3: "",
					firstItemTitleEg3: "",
					firstItemContent3: "",
					firstItemContentEg3: "",
					secondTitle: "",
					secondTitleEg: "",
					secondImg: "",
					secondTitle1: "",
					secondTitleEg1: "",
					secondTitle2: "",
					secondTitleEg2: "",
					secondTitle3: "",
					secondTitleEg3: "",
					secondTitle4: "",
					secondTitleEg4: "",
					secondTitle5: "",
					secondTitleEg5: "",
					secondTitle6: "",
					secondTitleEg6: "",
					secondTitle7: "",
					secondTitleEg7: "",
					secondTitle8: "",
					secondTitleEg8: "",
					thirdTitle: "",
					thirdTitleEg: "",
					thirdTitle1: "",
					thirdTitleEg1: "",
					thirdImg: "",
					thirdTitle2: "",
					thirdTitleEg2: "",
					thirdTitle3: "",
					thirdTitleEg3: "",
					thirdImg1: "",
					thirdTitle4: "",
					thirdTitleEg4: "",
					thirdTitle5: "",
					thirdTitleEg5: "",
					fourthImg: "",
					fourthTitle: "",
					fourthTitleEg: "",
					fourthContent: "",
					fourthContentEg: "",
					fourthImg1: "",
					fourthTitle1: "",
					fourthTitleEg1: "",
					fourthContent1: "",
					fourthContentEg1: "",
					fourthImg2: "",
					fourthTitle2: "",
					fourthTitleEg2: "",
					fourthContent2: "",
					fourthContentEg2: ""
				},
				btnText: "提 交",
				textTitle: "新增产品",
				isDis: false,
				user: JSON.parse(sessionStorage.getItem('CurUser')),
				uploadUrl: "https://zyjwsys.sxsla.cn/files/upload",
				fileList: [],
				fileList1: [],
				imageUrl: '',
				imgType: 0,
				fullscreenLoading: false
			}
		},
		computed: {
			// 初始化富文本
			initEditor() {
				return {
					height: 300,
					branding: false,
					skin_url: '/tinymce/skins/ui/oxide',
					content_css: '/tinymce/skins/content/default/content.css',
					language_url: '/tinymce/langs/zh_CN.js',
					language: 'zh_CN',
					plugins: 'code print preview fullscreen paste searchreplace save autosave link autolink image imagetools media table codesample lists advlist hr charmap emoticons anchor directionality pagebreak quickbars nonbreaking visualblocks visualchars wordcount',
					toolbar: 'fullscreen preview code | undo redo | forecolor backcolor | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | formatselect fontselect fontsizeselect | link image media emoticons charmap anchor pagebreak codesample | ltr rtl',
					toolbar_drawer: 'sliding',
					fontsize_formats: '8px 10px 12px 14px 18px 24px 36px 48px 60px 72px 80px 90px 100px 110px 120px 140px 180px',
					images_upload_handler: (blobInfo, success, error) => {
						let file = blobInfo.blob();
						// 使用axios上传
						const formData = new FormData();
						formData.append('file', file, file.name);
						this.$http.post('https://zyjwsys.sxsla.cn/files/upload', formData).then(res => {
							if (res.data.code == 0) {
								success(res.data.data);
							} else {
								error(res.data.msg);
							}
						}).catch(e => {
							console.error(e);
							error(e.message);
						});
					},
					file_picker_types: 'media',
					file_picker_callback: () => {}
				}
			}
		},
		beforeMount() {
			// this.utils.Logger("1111111111111111");
			this.getData();
			// this.loadPost();
		},
		methods: {
			handleAvatarSuccess(res, file) {
				if (this.imgType == 1)
					this.form.image = "https://image.sxsla.cn/files/" + res.data.name;
				else if (this.imgType == 3)
					this.form.secondImg = "https://image.sxsla.cn/files/" + res.data.name;

				this.fullscreenLoading = false;
			},
			handleAvatarSuccess1(res, file) {
				this.form.thirdImg = "https://image.sxsla.cn/files/" + res.data.name;
				this.fullscreenLoading = false;
			},
			handleAvatarSuccess2(res, file) {
				this.form.thirdImg1 = "https://image.sxsla.cn/files/" + res.data.name;
				this.fullscreenLoading = false;
			},

			handleAvatarSuccess3(res, file) {
				this.form.fourthImg = "https://image.sxsla.cn/files/" + res.data.name;
				this.fullscreenLoading = false;
			},

			handleAvatarSuccess4(res, file) {
				this.form.fourthImg1 = "https://image.sxsla.cn/files/" + res.data.name;
				this.fullscreenLoading = false;
			},
			handleAvatarSuccess5(res, file) {
				this.form.fourthImg2 = "https://image.sxsla.cn/files/" + res.data.name;
				this.fullscreenLoading = false;

			},
			beforeAvatarUpload1(file) {
				this.fullscreenLoading = true;
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 20;

				// if (!isJPG) {
				// 	this.$message.error('上传头像图片只能是 JPG 格式!');
				// }
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 20MB!');
				}
				
				this.getImageSize(file).then(size => {
					if (size.width / size.height !== 2) {
						this.$message.error('宽高比例必须为1:2')
						return Promise.reject()
					}
				})
				return isLt2M;
			},
			getImageSize(file) {
				return new Promise((resolve, reject) => {
					const reader = new FileReader()
					reader.onload = e => {
						const image = new Image()
						image.onload = () => {
							resolve({
								width: image.width,
								height: image.height
							})
						}
						image.src = e.target.result
					}
					reader.readAsDataURL(file)
				})
			},
			beforeAvatarUpload2(file) {
				this.fullscreenLoading = true;
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 20;
			
				// if (!isJPG) {
				// 	this.$message.error('上传头像图片只能是 JPG 格式!');
				// }
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 20MB!');
				}
				
				this.getImageSize(file).then(size => {
					if (size.width == 1024 && size.height == 520) {
						this.$message.error('只能上传jpg/png文件，且尺寸宽高为1024X520')
						return Promise.reject()
					}
				})
				return isLt2M;
			},
			beforeAvatarUpload4(file) {
				this.fullscreenLoading = true;
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 20;
			
				// if (!isJPG) {
				// 	this.$message.error('上传头像图片只能是 JPG 格式!');
				// }
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 20MB!');
				}
				
				this.getImageSize(file).then(size => {
					if (size.width != 1024 && size.height != 642) {
						this.$message.error('只能上传jpg/png文件，且尺寸宽高为1024X520')
						return Promise.reject()
					}
				})
				return isLt2M;
			},
			beforeAvatarUpload5(file) {
				this.fullscreenLoading = true;
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 20;
			
				// if (!isJPG) {
				// 	this.$message.error('上传头像图片只能是 JPG 格式!');
				// }
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 20MB!');
				}
				
				this.getImageSize(file).then(size => {
					if ((size.width != 1024 && size.height != 520) && (size.width != 550 && size.height != 345)) {
						this.$message.error('只能上传jpg/png文件，且尺寸宽高为1024X520')
						return Promise.reject()
					}
				})
				return isLt2M;
			},
			beforeAvatarUpload(file) {
				this.fullscreenLoading = true;
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 20;
			
				// if (!isJPG) {
				// 	this.$message.error('上传头像图片只能是 JPG 格式!');
				// }
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isLt2M;
			},
			
			mod(row, type) {
				this.form = row;
				this.imgType = type;
				this.btnText = "保存";
				if (type == 1) {
					this.textTitle = '修改产品信息'
					this.centerDialogVisible = true;
				} else if (type == 2) {
					this.textTitle = '编辑第一模块数据'
					this.centerDialogVisible1 = true;
				} else if (type == 3) {
					this.textTitle = '编辑第二模块数据'
					this.centerDialogVisible2 = true;
				} else if (type == 4) {
					this.textTitle = '编辑第三模块数据'
					this.centerDialogVisible3 = true;
				} else if (type == 5) {
					this.textTitle = '编辑第四模块数据'
					this.centerDialogVisible4 = true;
				}
			},
			resetForm() {
				this.$refs.form.resetFields();
			},
			save() {
				var that = this;
				this.$refs.form.validate((valid) => {
					if (valid) {
						if (that.btnText == "提交") {
							this.form.isSy = parseInt(this.form.isSy);
							this.utils.requestPost(this, "/goods/add", this.form, function(res, total) {
								that.centerDialogVisible = false;
								that.getData();
								that.utils.showMessage("success", "创建成功");
							});
						} else {
							this.form.isSy = parseInt(this.form.isSy);
							this.utils.requestPost(this, "/goods/mod", this.form, function(res, total) {
								that.centerDialogVisible = false;
								that.centerDialogVisible1 = false;
								that.centerDialogVisible2 = false;
								that.centerDialogVisible3 = false;
								that.centerDialogVisible4 = false;
								that.getData();
								that.utils.showMessage("success", "修改成功");
							});
						}
					} else {
						that.utils.showMessage("error", "请输入正确的内容");
						return false;
					}
				});

			},
			add() {
				var that = this;
				this.btnText = "提交";
				this.textTitle = '添加产品信息'
				this.imgType = 1;
				this.form = {
					id: "",
					name: "",
					nameEg: "",
					image: "",
					content: "",
					contentEg: "",
					firstTitle: "",
					firstTitleEg: "",
					type: "",
					isSy: 1,
					firstSubTitle: "",
					firstSubTitleEg: "",
					firstItemTitle: "",
					firstItemTitleEg: "",
					firstItemContent: "",
					firstItemContentEg: "",
					firstImg: "",
					firstItemTitle1: "",
					firstItemTitleEg1: "",
					firstItemContent1: "",
					firstItemContentEg1: "",
					firstItemTitle2: "",
					firstItemTitleEg2: "",
					firstItemContent2: "",
					firstItemContentEg2: "",
					firstItemTitle3: "",
					firstItemTitleEg3: "",
					firstItemContent3: "",
					firstItemContentEg3: "",
					secondTitle: "",
					secondTitleEg: "",
					secondImg: "",
					secondTitle1: "",
					secondTitleEg1: "",
					secondTitle2: "",
					secondTitleEg2: "",
					secondTitle3: "",
					secondTitleEg3: "",
					secondTitle4: "",
					secondTitleEg4: "",
					secondTitle5: "",
					secondTitleEg5: "",
					secondTitle6: "",
					secondTitleEg6: "",
					secondTitle7: "",
					secondTitleEg7: "",
					secondTitle8: "",
					secondTitleEg8: "",
					thirdTitle: "",
					thirdTitleEg: "",
					thirdTitle1: "",
					thirdTitleEg1: "",
					thirdImg: "",
					thirdTitle2: "",
					thirdTitleEg2: "",
					thirdTitle3: "",
					thirdTitleEg3: "",
					thirdImg1: "",
					thirdTitle4: "",
					thirdTitleEg4: "",
					thirdTitle5: "",
					thirdTitleEg5: "",
					fourthImg: "",
					fourthTitle: "",
					fourthTitleEg: "",
					fourthContent: "",
					fourthContentEg: "",
					fourthImg1: "",
					fourthTitle1: "",
					fourthTitleEg1: "",
					fourthContent1: "",
					fourthContentEg1: "",
					fourthImg2: "",
					fourthTitle2: "",
					fourthTitleEg2: "",
					fourthContent2: "",
					fourthContentEg2: ""
				};
				this.centerDialogVisible = true;
				this.$nextTick(() => {
					that.resetForm();
				})
			},
			reset() {
				this.name = "";
				this.type = "";
			},
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.getData();
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getData();
			},
			deleteRow(row){
				var that = this;
				this.utils.requestPost(this, "/goods/delete", row, function(res, total) {
					that.getData();
					that.utils.showMessage("success", "删除成功");
				});
			},
			getData() {
				var that = this;
				var params = {
					"pageSize": this.pageSize,
					"pageNum": this.page,
					"param": {
						"name": this.name,
						"type": this.type
					}
				};
				this.utils.requestPost(this, "/goods/getDataList", params, function(res, total) {
					that.tableData = res;
					that.total = total;
				});
			}
		}
	}
</script>

<style scoped>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>
